import React, { FC } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { LeftNav } from 'components/organisms/left-nav';
import { RoutePaths } from 'constant';
import { useAccount } from 'hooks/use-account';

export const RouterShellComponent = styled.div`
  --page-background: var(--white-100);

  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  align-content: stretch;
  max-height: 100vh;
  min-height: 100vh;
  height: 100vh;
  background: var(---page-background);
  overflow: hidden;
`;

export const RouterShell: FC = ({ children }) => {
  const {
    company: { companyLogoUrl },
  } = useAccount();
  const {
    location: { pathname },
  } = useHistory();

  const excludedRoutes = [RoutePaths.respSpacesTab];
  const isExcludedRoute =
    excludedRoutes.includes(pathname) || pathname.includes('responsive');

  return (
    <RouterShellComponent>
      {!isExcludedRoute ? <LeftNav logo={companyLogoUrl} /> : null}
      {children}
    </RouterShellComponent>
  );
};
